import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { MerchantOverviewMovementPage } from "./../merchant-overview-movement/merchant-overview-movement";
import { MerchantOverviewCashPage } from "./../merchant-overview-cash/merchant-overview-cash";
import { MerchantOverviewPlazaPage } from "./../merchant-overview-plaza/merchant-overview-plaza";
// import { MerchantOverviewStockPage } from './../merchant-overview-stock/merchant-overview-stock';
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-merchant-overview",
  templateUrl: "merchant-overview.html",
})
export class MerchantOverviewPage {
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad PlazaOverviewPage');
  }

  backPage() {
    this.navCtrl.push(MerchantHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  cash() {
    this.navCtrl.push(MerchantOverviewCashPage);
  }

  plazamap() {
    this.navCtrl.push(MerchantOverviewPlazaPage);
  }

  movement() {
    this.navCtrl.push(MerchantOverviewMovementPage);
  }

  // stock() {
  //   this.navCtrl.push(MerchantOverviewStockPage);
  // }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview/merchant-overview.ts